import { parseNodeName } from './ParseNodeName.ts'

// Function to register all global filters
export default function registerFilters(app: any): void {
  app.config.globalProperties.$parseNodeName = parseNodeName
  // Add more filters here as needed
}
